import { z } from "zod";

import { VersionStringSchema } from "../manifest/schemas";
import type { ModuleRef, WireModuleRef } from "./types";

/**
 * Zod schema for {@link ModuleRef} — a reference to a module with props and
 * minimum version. `props` must be a plain JSON-serialisable object on the
 * wire; functions are rejected because they can't survive serialisation.
 */
export const ModuleRefSchema = z.object({
  _tag: z.literal("ModuleRef"),
  moduleId: z.string().min(1),
  minVersion: VersionStringSchema,
  props: z.record(z.string(), z.unknown()),
  fetcherConfig: z.unknown().optional(),
}) satisfies z.ZodType<ModuleRef>;

/**
 * Zod schema for {@link WireModuleRef} — bare module identity. No `props`
 * (may be function-form at the source) and no `fetcherConfig` (server-only).
 */
export const WireModuleRefSchema = z.object({
  _tag: z.literal("ModuleRef"),
  moduleId: z.string().min(1),
  minVersion: VersionStringSchema,
}) satisfies z.ZodType<WireModuleRef>;
